export default "__VITE_ASSET__CMOMbu9y__"